export enum PatientTabType {
  CareTeam = 'care-team',
  PatientSettings = 'patient-settings',
  MedicalInfo = 'medical-info'
}
